import {
  resetSelectedCasesFilters,
  selectCasesPagination,
  setCasesFinding,
  setCasesPagination,
  useAppDispatch,
  useAppSelector,
} from '@/store';
import { InputSearchHandle } from '@repo/atomic-components';
import { KeyboardEvent as SyntheticKeyboardEvent, useCallback, useRef } from 'react';

export const useCasesSearch = () => {
  const searchInputRef = useRef<InputSearchHandle>(null);

  const casesPagination = useAppSelector(selectCasesPagination);

  const dispatch = useAppDispatch();

  const handleSearchInputKeyDown = (event: SyntheticKeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && searchInputRef.current) {
      // Submitting a search clears any column / quick filters — the search
      // is treated as a fresh top-level query, so a stale status or
      // assigned-to filter can't hide matching cases.
      dispatch(resetSelectedCasesFilters());
      dispatch(setCasesFinding(searchInputRef.current.value));
      dispatch(setCasesPagination({ ...casesPagination, pageIndex: 0 }));
    }
  };

  const handleResetClick = useCallback(() => {
    dispatch(setCasesFinding(''));
    dispatch(setCasesPagination({ ...casesPagination, pageIndex: 0 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    searchInputRef,
    handleResetClick,
    handleSearchInputKeyDown,
  };
};
